var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundFlagIt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p3rwizagza)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "dpkct0k72b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dpkct0k72b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.62 24h4.552c.457 0 .828-.537.828-1.2V1.2c0-.663-.37-1.2-.828-1.2H.828C.37 0 0 .537 0 1.2v21.6c0 .663.37 1.2.828 1.2H18.62z",
    fill: "#CE2B37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2 0v24H.8c-.441-.002-.799-.538-.8-1.2V1.2C.001.538.359.002.8 0h6.4z",
    fill: "#009246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2 0h9.6v24H7.2V0z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "p3rwizagza"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundFlagIt);
export default __webpack_public_path__ + "static/media/round-flag-it.2b150fc57c452bb731ab8ec292bc4b66.svg";
export { ForwardRef as ReactComponent };